// client/src/services/transactionService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

const getAccounts = async () => {
  const response = await fetch(`${apiUrl}/accounts`, { headers: authHeaders() });
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement des comptes.');
  return await response.json();
};

const getTransactions = async (accountId, page = 1, limit = 50, filters = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (filters.categoryId) params.append('categoryId', filters.categoryId);
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.search) params.append('search', filters.search);
  if (filters.minAmount != null) params.append('minAmount', filters.minAmount);
  if (filters.maxAmount != null) params.append('maxAmount', filters.maxAmount);

  const response = await fetch(
    `${apiUrl}/accounts/${accountId}/transactions?${params.toString()}`,
    { headers: authHeaders() }
  );
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement des transactions.');
  return await response.json();
};

// FormData : pas de Content-Type (le navigateur le génère avec le boundary)
const analyzeCSV = async (formData) => {
  const response = await fetch(`${apiUrl}/upload/analyze`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || "Erreur lors de l'analyse.");
  return result;
};

const importTransactions = async (formData) => {
  const response = await fetch(`${apiUrl}/upload/import`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || "Erreur lors de l'importation.");
  return result;
};

const transactionService = {
  getAccounts,
  getTransactions,
  analyzeCSV,
  importTransactions
};

export default transactionService;
